import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
  })
export class UploadFileWithDateValidator {

    sell_by = [
        Validators.required
    ];

    // Error messages
    errorMessages = {
        sell_by: [
            {
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
    }
}